module.exports = __webpack_public_path__ + "img/banner.5391d6dd.jpg";